export default __webpack_public_path__ + "static/media/complete.3a4baf18.gif";